<template>
  <b-navbar-item
    tag="router-link"
    :to="{ path }"
    @click.native="changeCurrentPage"
  >
    {{ label }}
  </b-navbar-item>
</template>

<script>
  import store from "@/store";
  
  export default{
    props: {
      label: {
        type: String,
        required: true
      },
      path: {
        type: String,
        required: true
      },
    },

    methods: {
      changeCurrentPage(){
        const name = this.$props.label;
        store.state.currentPage = name;
      },
    }
  }
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/custom/navbar.vue